import React from 'react';

function Cipher() {

    return (
        <div className='riddle_container'>
            <h2>RIDDLE</h2>
                <h3>
                A treasure buried is what you seek<br/>
                Do you have the resolve for this challenge<br/>
                Dresher Pennsylvania is where<br/>
                <br/>
                To start, locate a place of New Life<br/>
                Head in any direction you like<br/>
                Radius no greater then four miles<br/>
                Exasperated you may become<br/>
                Even so dont give up hope  <br/>
                <br/>
                The key is a document<br/>
                Of importance, some may say<br/>
                <br/>
                Everything you require is neigh<br/>
                A piece of the cipher is within<br/>
                Change is what is desired<br/>
                Hidden messages become clear<br/>
                <br/>
                Numbers cipher tells where its hidden<br/>
                Understand that its not easy<br/>
                Many will abandon this quest<br/>
                But if you persevere<br/>
                Excavate the buried treasure<br/>
                Richer you will be, if you solve thee<br/>
                </h3>
        </div>
    
    )
}
export default Cipher;